import { render } from "./GridItemCarousel.vue?vue&type=template&id=6b621115"
import script from "./GridItemCarousel.vue?vue&type=script&lang=js"
export * from "./GridItemCarousel.vue?vue&type=script&lang=js"

import "./GridItemCarousel.vue?vue&type=style&index=0&id=6b621115&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__